import React, {Component} from 'react'
import ReactGA from 'react-ga';
import {constants} from "./constants";


export const downLoadVisit = (store, source) => {
	console.log(store, source);
	ReactGA.event({
		action: 'Download Visit',
		category: store + ':' + source,
		label: store,
		value: 1
	});

	window.open(store === 'ios' ? constants.iosUrl : constants.androidUrl, "_blank")
};



// WEBPACK FOOTER //
// ./src/data/analytics.jsx